'use strict';

import './components/no-js';
// import './components/cookie';
import './components/unsupported-browsers';
import './components/toggle';
import './components/accordion';
import './components/modal';
import './components/tabs';
import './components/countdown';
import initActionPlanNav from './components/action-plan-nav';
initActionPlanNav();
import initProjectsMap from './components/projects-map';
initProjectsMap();
import initDesktopNav from './components/desktop-nav';
initDesktopNav();
import './components/mobile-nav-accordion';
